import React, { useState, useEffect } from "react";

export const svg = `<svg width="18" height="18" viewbox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.964 8.964c-.553-.338-.378-.101-.145.121.986.932 1.64 1.847 1.882 2.64.158.516.016.83-.22.378-.36-.685-.83-1.212-1.12-1.445-.286-.23-.28-.118-.142.064.563.753.896 1.51.563 2.097-.55.962-2.76.719-4.936-.54C5.08 10.678 3.373 8.487 4 7.366c.272-.49 1.013-.692 1.888-.617.185.016.175-.044.01-.088-1.043-.277-2.275-.017-2.713.746-.798 1.387 1.06 3.966 4.154 5.758.657.378 1.512.804 2.522 1.141.612.206.525.452-.529.247-1.118-.216-2.511-.8-3.828-1.577-.38-.223-.43-.135-.148.142.263.257.758.648 1.36 1.006 3.07 1.833 6.905 2.312 8.006.398.983-1.711-.785-4.354-2.757-5.56Z"></path><path d="m2.25 2.25 1.65 3h3.6v5.67c-.05-.038.046.037 0 0 .832.632 2.083 1.264 3 1.379-.047-.004.05.006 0 0V5.25h3.6l1.65-3H2.25Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
